import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CentralTechViewIssue from "./ViewIssue";
import {
  complainRaisedTicket,
  reopenComplain,
  saveComplaintReplySupport,
  saveAssigneeDetails,
  subIssueDropdown,
  fetchAllIssuesList,
  saveRaiseIssueSupport,
  saveCteComplainRemarks,
  fetchCteIssueList,
} from "services/redux/fileComplain/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { calculateDistance, getDistanceData, getSiteData } from 'services/redux/DistanceCalculator/action';
import { rmCheckOutRequest } from 'services/redux/networkEngineer/action';

const mapStateToProps = (state) => ({
    complainList: state.fileComplainReducer.fetchComplain,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    getSubIssueDropdown: state.fileComplainReducer.getSubIssueDropdown,
    getAllIssuesListing: state.fileComplainReducer.getAllIssuesListing,
    saveRaiseIssueReply: state.fileComplainReducer.saveRaiseIssueReply,
    cteComplainRemarks: state.fileComplainReducer.cteComplainRemarks,
    cteIssueList: state.fileComplainReducer.cteIssueList,
    distanceData: state.leadDataReducer.distanceDetails,
    siteData: state.leadDataReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    reopenComplain,
    complainRaisedTicket,
    saveComplaintReplySupport,
    documentUploadUrlPublic,
    saveAssigneeDetails,
    subIssueDropdown,
    fetchAllIssuesList,
    saveRaiseIssueSupport,
    saveCteComplainRemarks,
    fetchCteIssueList,
    calculateDistance,
    getDistanceData,
    getSiteData,
    rmCheckOut: rmCheckOutRequest,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CentralTechViewIssue);
